import React from 'react';
import useMediaSelect from "app/app/mediaSelector/hooks/use-media-select";

function MediaCount({className, numberOnly}) {
    const {selectedMedia} = useMediaSelect();
    let classNames = ['media-count', className].join(" ");

    return (
        <div className={classNames}>
            <span>{selectedMedia.length}</span>
            {!numberOnly && <span> {selectedMedia.length == 1 ? 'fil' : 'filer'}</span>}
        </div>
    );
}

export default MediaCount;
